const FunctionButtonComponent = {
    templateUrl: '/formViewer/component/functionButton/functionButton.tpl.html',
    controller: 'functionButtonController',
    bindings: {
        fieldStructure: '<'
    }
};

angular.module('umCore')
    .component('uiFunctionButton', FunctionButtonComponent);
